import { Users, BarChart2, CheckCircle, ArrowRight } from 'lucide-react';
import React from 'react';
import styles from './index.module.less';
import { useTranslation } from 'next-i18next';

export default function HowItWorksSection() {
  const { t } = useTranslation();

  const steps = [
    {
      title: t('Enter Username'),
      description: t('Simply input the Instagram username you want to analyze.'),
      icon: Users,
    },
    {
      title: t('We Analyze'),
      description: t('Our tool quickly processes the public data associated with the account.'),
      icon: BarChart2,
    },
    {
      title: t('Get Results'),
      description: (
        <>
          <p>{t('View the most recent followers or accounts followed by the user.')}</p>
          <div>
            <a
              href="#"
              className={styles['try-now-link']}
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
            >
              {t('Try Now')}
            </a>
          </div>
        </>
      ),
      icon: CheckCircle,
    },
  ];

  return (
    <section className={styles['how-it-works-section']}>
      <h2 className={styles.title}>{t("How Dolphinradar's Recent Follow Tool Works")}</h2>
      <div className={styles['steps-container']}>
        {steps.map((step, index) => (
          <div key={index} className={styles.step}>
            <div className={styles['icon-container']}>{React.createElement(step.icon, { className: styles.icon })}</div>
            <h3 className={styles['step-title']}>{step.title}</h3>
            <div className={styles['step-description']}>{step.description}</div>
          </div>
        ))}
        <div className={styles.arrow}>
          <ArrowRight className={styles.arrowIcon} />
        </div>
        <div className={styles.arrow}>
          <ArrowRight className={styles.arrowIcon} />
        </div>
      </div>
    </section>
  );
}
